(() => {
  'use strict';

  const updateHalloweenCountdown = () => {
    const targets = document.querySelectorAll('[data-wh173-countdown]');
    if (!targets.length) return;
    const now = new Date();
    const year = now.getMonth() > 9 || (now.getMonth() === 9 && now.getDate() > 31) ? now.getFullYear() + 1 : now.getFullYear();
    const target = new Date(year, 9, 31, 0, 0, 0, 0);
    const diff = Math.max(0, target.getTime() - now.getTime());
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    const text = `${days}d · ${hours}h · ${mins}m`;
    targets.forEach((el) => { el.textContent = text; });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHalloweenCountdown, { once: true });
  } else {
    updateHalloweenCountdown();
  }
  window.setInterval(updateHalloweenCountdown, 60000);
})();
